import { ButtonType } from 'core/enums/button-type';
import { useDialog } from 'core/providers/DialogProvider';
import SharedDialogBase from 'shared/components/dialog-base/dialog-base';
import { ISharedDialogButton } from 'shared/components/dialog-base/dialog-base-interface';
import { GoogleMap, Marker } from '@react-google-maps/api';
import PinUnfulfilled from 'assets/images/map-pin-unfulfilled.png';
import { useCallback, useState } from 'react';

const ViewLocationDialog = ({ position }: { position?: { latitude: number; longitude: number } }) => {
  const dialog = useDialog();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [map, setMap] = useState<google.maps.Map | null>(null);

  const onLoad = useCallback(
    (map: google.maps.Map) => {
      if (position) {
        map.setCenter({ lat: position.latitude, lng: position.longitude });
        map.setZoom(11);
        setMap(map);
      }
    },
    [position]
  );

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const customButtons: ISharedDialogButton[] = [
    {
      key: 'close',
      type: ButtonType.Button,
      buttonProps: {
        onClick: () => dialog?.closeDialog(),
        appearance: 'primary',
        label: 'Close',
        type: 'button',
      },
    },
  ];

  const containerStyle = {
    width: '100%',
    height: '400px',
  };

  return position ? (
    <SharedDialogBase
      title='View Location'
      customContentTemplate={
        <GoogleMap mapContainerStyle={containerStyle} zoom={11} onLoad={onLoad} onUnmount={onUnmount}>
          <Marker
            label={{
              text: ' ',
              color: 'white',
            }}
            icon={{
              url: PinUnfulfilled,
              labelOrigin: new google.maps.Point(18, 16),
            }}
            position={{ lat: position.latitude, lng: position.longitude }}
          />
        </GoogleMap>
      }
      customButtons={customButtons}
    />
  ) : null;
};

export default ViewLocationDialog;
